import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import i18n from 'i18next';
import { call, cancelled, put, select, takeLatest } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { getErrorMessageFromAPI } from '../../utilz';
import { setAppLoader } from '../common/CommonActions';
import { setPurchaseOrderFilters } from '../purchaseOrder/PurchaseOrderActions';
import {
  cancelShipmentInError,
  cancelShipmentInSuccess,
  createShipmentInError,
  createShipmentInSuccess,
  deleteVendorAddressFail,
  deleteVendorAddressSuccess,
  getBarCodeError,
  getBarCodeSuccess,
  getCustomerRouterSettingFail,
  getCustomerRouterSettingSuccess,
  getPOInfoInError,
  getPOInfoInSuccess,
  getPackagesInError,
  getPackagesInSuccess,
  getRoutingGuideInError,
  getRoutingGuideInSuccess,
  getVendorConsigneeListInError,
  getVendorConsigneeListInSuccess,
  getVendorPurchaseOrderListInError,
  getVendorPurchaseOrderListInSuccess,
  getVendorSearchFail,
  getVendorSearchSuccess,
  getVendorShipmentDetailListInError,
  getVendorShipmentDetailListInSuccess,
  getVendorShipmentItemDetailListInError,
  getVendorShipmentItemDetailListInSuccess,
  getVendorShipmentLadingListInError,
  getVendorShipmentLadingListInSuccess,
  getVendorShipmentSummaryListInError,
  getVendorShipmentSummaryListInSuccess,
  getVendorShipperListInError,
  getVendorShipperListInSuccess,
  resetOrderListFail,
  resetOrderListSuccess,
  savePackageInError,
  savePackageInSuccess,
  saveRegularOrdersInError,
  saveRegularOrdersInSuccess,
  saveShipmentInError,
  saveShipmentInSuccess,
  saveVendorAddressInError,
  saveVendorAddressInSuccess,
  setTotalPurchaseOrderCount,
} from './POVActions';
import {
  cancelShipmentEffect,
  createPovShipmentEffect,
  deleteVendorAddressValue,
  getBarCodeDetails,
  getConsigneeList,
  getCustomerRouterSettingService,
  getPOInfoEffect,
  getPackagesEffect,
  getRoutingGuideEffect,
  getShipmentDetailsLists,
  getShipmentItemDetailsLists,
  getShipmentLadingList,
  getShipmentSummaryList,
  getShippersList,
  getVendorPurchaseOrdersEffect,
  getVendorSearchValues,
  resetOrderListService,
  savePackageEffect,
  saveRegularOrderDataAPI,
  saveShipmentEffect,
  saveVendorAddressEffect,
} from './POVEffects';
import POVTypes from './POVTypes';

export const purchaseOrderState = (state) => state.purchaseOrder;

function* getVendorPurchaseOrderList({ payload, isPageIndex }) {
  try {
    const { data } = yield call(getVendorPurchaseOrdersEffect, payload);
    const { selectedPurchaseOrders } = yield select(purchaseOrderState);
    if (isPageIndex) {
      yield put(
        setPurchaseOrderFilters({
          pageIndex: payload.pageIndex + 1,
        }),
      );
    }
    yield put(
      getVendorPurchaseOrderListInSuccess({
        data: data.totalData,
        isCheckItemLevelConsignee: data.isCheckItemLevelConsignee,
        selectedPurchaseOrders: selectedPurchaseOrders,
      }),
    );
    yield put(setTotalPurchaseOrderCount({ totalCount: data.count.totalCount }));
  } catch (e) {
    yield put(getVendorPurchaseOrderListInError({ message: getErrorMessageFromAPI(e) }));
  } finally {
    if (yield cancelled()) {
      yield put(
        getVendorPurchaseOrderListInError({
          message: 'Fetch data saga was cancelled',
        }),
      );
      yield call(getVendorPurchaseOrderList, { payload, isPageIndex: true });
    }
  }
}

function* getPOInfo({ payload }) {
  try {
    const { data } = yield call(getPOInfoEffect, payload);
    const dataTemp = [...data];
    dataTemp.forEach((element) => {
      element.uniqueId = uuidv4();
    });
    yield put(
      getPOInfoInSuccess({
        data: dataTemp,
      }),
    );
  } catch (e) {
    yield put(getPOInfoInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getPackagesInfo({ payload }) {
  try {
    const { data } = yield call(getPackagesEffect, payload);
    yield put(
      getPackagesInSuccess({
        data: data,
      }),
    );
  } catch (e) {
    yield put(getPackagesInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* saveRegularOrderData({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(saveRegularOrderDataAPI, payload);
    if (data[0].status === 1) {
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.SUCCESS,
        message: i18n.t('translation:default.notification.purchaseOrderCreated'),
      });
      yield put(
        saveRegularOrdersInSuccess({
          data: data,
        }),
      );
    } else {
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.ERROR,
        message: data[0].message,
      });
      saveRegularOrdersInError({
        message: data[0].message,
        data: [],
      });
    }
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(
      saveRegularOrdersInError({
        message: getErrorMessageFromAPI(e),
        data: [],
      }),
    );
    yield put(setAppLoader(false));
  }
}

function* savePackageDetails({ payload }) {
  try {
    const { data } = yield call(savePackageEffect, payload);
    yield put(
      savePackageInSuccess({
        data: data,
      }),
    );
  } catch (e) {
    yield put(
      savePackageInError({
        message: getErrorMessageFromAPI(e),
        data: [],
      }),
    );
  }
}

function* saveShipmentDetails({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data, status } = yield call(saveShipmentEffect, payload);
    if (status === 200) {
      if (data === 'Success') {
        yield put(
          saveShipmentInSuccess({
            data: data,
          }),
        );
      } else {
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.ERROR,
          message: data,
        });
        yield put(
          saveShipmentInError({
            message: getErrorMessageFromAPI(data),
            data: [],
          }),
        );
      }
    } else {
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.ERROR,
        message: i18n.t('translation:default.fields.kindlyTryAgain'),
      });
    }
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(
      saveShipmentInError({
        message: getErrorMessageFromAPI(e),
        data: [],
      }),
    );
    yield put(setAppLoader(false));
  }
}

function* getShippers({ payload }) {
  try {
    const { data } = yield call(getShippersList, payload);
    yield put(getVendorShipperListInSuccess({ data: data }));
  } catch (e) {
    yield put(getVendorShipperListInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getConsignee({ payload }) {
  try {
    const { data } = yield call(getConsigneeList, payload);
    yield put(getVendorConsigneeListInSuccess({ data: data }));
  } catch (e) {
    yield put(getVendorConsigneeListInError({ message: getErrorMessageFromAPI(e) }));
  }
}
function* getShipmentDetails({ payload }) {
  try {
    const { data } = yield call(getShipmentDetailsLists, payload);
    yield put(getVendorShipmentDetailListInSuccess({ data: data }));
  } catch (e) {
    yield put(
      getVendorShipmentDetailListInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getShipmentItemDetailsSaga({ payload }) {
  try {
    const { data } = yield call(getShipmentItemDetailsLists, payload);
    yield put(getVendorShipmentItemDetailListInSuccess({ data: data }));
  } catch (e) {
    yield put(
      getVendorShipmentItemDetailListInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getBarCodeSaga({ payload }) {
  try {
    const { data } = yield call(getBarCodeDetails, payload);
    yield put(getBarCodeSuccess({ data: data }));
  } catch (e) {
    yield put(
      getBarCodeError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getShipmentSummary({ payload }) {
  try {
    const { data } = yield call(getShipmentSummaryList, payload);
    yield put(getVendorShipmentSummaryListInSuccess({ data: data }));
  } catch (e) {
    yield put(
      getVendorShipmentSummaryListInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getShipmentLading({ payload }) {
  try {
    const { data } = yield call(getShipmentLadingList, payload);
    yield put(getVendorShipmentLadingListInSuccess({ data: data }));
  } catch (e) {
    yield put(
      getVendorShipmentLadingListInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* createShipment({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data, status } = yield call(createPovShipmentEffect, payload);

    if (status === 200) {
      if (data && data.length > 0 && (data[0].status === 1 || data[0].status === 2)) {
        const messages = {
          default: `${i18n.t('translation:default.navMenu.shipment')} ${data[0].shipmentNumber}${i18n.t('translation:default.fields.hasBeenCreated')}`,
          'Pre-Booking': `The Pre-Booking No. - ${data[0].shipmentNumber}`,
        };
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.SUCCESS,
          message: messages[payload.shipmentType] || messages.default,
        });
        yield put(
          createShipmentInSuccess({
            data: data,
          }),
        );
        yield put(setAppLoader(false));
      } else {
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.ERROR,
          message: data[0].errorMessage,
        });
        yield put(
          createShipmentInError({
            message: i18n.t('translation:default.fields.kindlyTryAgain'),
            data: [],
          }),
        );
        yield put(setAppLoader(false));
      }
    } else {
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.ERROR,
        message: i18n.t('translation:default.fields.kindlyTryAgain'),
      });
      yield put(
        createShipmentInError({
          message: i18n.t('translation:default.notification.timeoutIssue'),
          data: [],
        }),
      );
      yield put(setAppLoader(false));
    }
  } catch (e) {
    yield put(setAppLoader(false));
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: getErrorMessageFromAPI(e),
    });
    yield put(
      createShipmentInError({
        message: getErrorMessageFromAPI(e),
        data: [],
      }),
    );
  }
}

function* saveVendorAddressData({ payload }) {
  try {
    const { data, status } = yield call(saveVendorAddressEffect, payload);
    if (status === 200) {
      if (data === 'Success') {
        yield put(saveVendorAddressInSuccess());
      } else {
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.ERROR,
          message: data[0].message,
        });
      }
    } else {
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.ERROR,
        message: i18n.t('translation:default.fields.kindlyTryAgain'),
      });
    }
  } catch (e) {
    yield put(
      saveVendorAddressInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* cancelShipment({ payload }) {
  try {
    const { data, status } = yield call(cancelShipmentEffect, payload);

    if (status === 200) {
      if (data && data === 1) {
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.SUCCESS,
          message: i18n.t('translation:default.notification.shipmentCancelled'),
        });
        yield put(
          cancelShipmentInSuccess({
            data: data,
          }),
        );
      } else {
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.ERROR,
          message: i18n.t('translation:default.fields.kindlyTryAgain'),
        });
      }
    } else {
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.ERROR,
        message: i18n.t('translation:default.fields.kindlyTryAgain'),
      });
    }
  } catch (e) {
    yield put(
      cancelShipmentInError({
        message: getErrorMessageFromAPI(e),
        data: [],
      }),
    );
  }
}

function* getVendorSearchActions({ payload }) {
  try {
    const { data } = yield call(getVendorSearchValues, payload);
    yield put(getVendorSearchSuccess({ data: data }));
  } catch (e) {
    yield put(getVendorSearchFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* deleteVendorAddress({ payload }) {
  try {
    yield call(deleteVendorAddressValue, payload);
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.SUCCESS,
      message: `${i18n.t('translation:default.fields.deleteVendorSuccessfully')}`,
    });
    yield put(deleteVendorAddressSuccess());
  } catch (e) {
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: i18n.t('translation:default.fields.kindlyTryAgain'),
    });
    yield put(deleteVendorAddressFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getCustomerRouterSettingAPI({ payload }) {
  try {
    const { data } = yield call(getCustomerRouterSettingService, payload);
    yield put(getCustomerRouterSettingSuccess({ data: data }));
  } catch (e) {
    yield put(getCustomerRouterSettingFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* resetOrderListSaga({ payload }) {
  try {
    const { data } = yield call(resetOrderListService, payload);
    yield put(resetOrderListSuccess({ data: data }));
  } catch (e) {
    yield put(resetOrderListFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getRoutingGuide({ payload }) {
  try {
    const { data } = yield call(getRoutingGuideEffect, payload);
    yield put(getRoutingGuideInSuccess({ data: data }));
  } catch (e) {
    yield put(getRoutingGuideInError({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* POVSagas() {
  yield takeLatest(POVTypes.GET_VENDOR_PURCHASE_ORDER_LIST_PROGRESS, getVendorPurchaseOrderList);
  yield takeLatest(POVTypes.GET_PO_INFO_PROGRESS, getPOInfo);
  yield takeLatest(POVTypes.GET_PACKAGE_INFO_PROGRESS, getPackagesInfo);
  yield takeLatest(POVTypes.SAVE_REGULAR_ORDER_DATA_PROGRESS, saveRegularOrderData);

  yield takeLatest(POVTypes.SAVE_PACKAGE_DETAILS_PROGRESS, savePackageDetails);
  yield takeLatest(POVTypes.SAVE_SHIPMENT_DETAILS_PROGRESS, saveShipmentDetails);
  yield takeLatest(POVTypes.GET_VENDOR_SHIPPER_LIST_PROGRESS, getShippers);
  yield takeLatest(POVTypes.GET_VENDOR_CONSIGNEE_LIST_PROGRESS, getConsignee);
  yield takeLatest(POVTypes.GET_VENDOR_SHIPMENT_DETAIL_LIST_PROGRESS, getShipmentDetails);
  yield takeLatest(POVTypes.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_PROGRESS, getShipmentItemDetailsSaga);

  yield takeLatest(POVTypes.GET_BAR_CODE, getBarCodeSaga);

  yield takeLatest(POVTypes.GET_VENDOR_SHIPMENT_SUMMARY_LIST_PROGRESS, getShipmentSummary);

  yield takeLatest(POVTypes.GET_VENDOR_SHIPMENT_LADING_LIST_PROGRESS, getShipmentLading);
  yield takeLatest(POVTypes.CREATE_SHIPMENT_PROGRESS, createShipment);
  yield takeLatest(POVTypes.CANCEL_SHIPMENT_PROGRESS, cancelShipment);
  yield takeLatest(POVTypes.RESET_ORDER_LIST, resetOrderListSaga);

  yield takeLatest(POVTypes.SAVE_VENDOR_ADDRESS_PROGRESS, saveVendorAddressData);
  yield takeLatest(POVTypes.GET_VENDOR_SEARCH, getVendorSearchActions);

  yield takeLatest(POVTypes.DELETE_VENDOR_ADDRESS, deleteVendorAddress);
  yield takeLatest(POVTypes.GET_CUSTOMER_ROUTING_SETTING, getCustomerRouterSettingAPI);
  yield takeLatest(POVTypes.GET_ROUTING_GUIDE, getRoutingGuide);
}
